/*** IMPORTS FROM imports-loader ***/
var define = false;

/*jslint unparam: true */

"use strict";

var ko = require("knockout");

var $ = require("../jquery");


// this logic was copied from knockout.js
function createKoBindingContext(dataItem, parentBindingContext, dataItemAlias) {
    var context = {};

    if (parentBindingContext) {
        ko.utils.extend(context, parentBindingContext); // Inherit $root and any custom properties
        context.$parentContext = parentBindingContext;
        context.$parent = parentBindingContext.$data;
        context.$parents = (parentBindingContext.$parents || []).slice(0);
        context.$parents.unshift(context.$parent);
    } else {
        context.$parents = [];
        context.$root = dataItem;
        context.ko = ko;
    }
    context.$data = dataItem;
    if (dataItemAlias) {
        context[dataItemAlias] = dataItem;
    }

    return context;
}

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
//  The "VirtualScrollViewModel" class
//  Implements logic of virtual scrolling
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
function VirtualScrollViewModel(items, viewport, content, rowHeight, itemTemplate, rootBindingContext) {

    // save initial values
    this.$viewport = viewport;
    this.$content = content;
    this.itemTemplate = itemTemplate;
    this.rootBindingContext = rootBindingContext;
    this.rowHeight = rowHeight;                     // row height
    this.viewportHeight = viewport.height();        // viewport height


    this._virtualHeight = 0;          // virtual height
    this._realHeight = 0;             // real scrollable height
    this._pageHeight = 0;             // page height
    this._pagesNumber = 0;            // number of pages
    this._jumpCoef = 0;               // "jumpiness" coefficient
    this._page = 0;                   // current page
    this._offset = 0;                 // current page offset
    this._prevScrollTop = 0;          // prvious value of scrollTop
    this.rows = {};                   // cached row nodes

    this.updateItems(items);

    // add event handler
    this.$viewport.scroll(this.onScroll.bind(this));
    // trigger to render initial
    this.$viewport.trigger("scroll");
}

//-------------------------------------------
VirtualScrollViewModel.prototype.onScroll = function virtualScrollViewModelOnScroll() {
    var scrollTop = this.$viewport.scrollTop();
    if (Math.abs(scrollTop - this._prevScrollTop) > this.viewportHeight) {
        this.onJump();
    } else {
        this.onNearScroll();
    }

    this.renderViewport();
};

//-------------------------------------------
VirtualScrollViewModel.prototype.updateItems = function virtualScrollViewModelUpdateItems(newItems) {
    this.items = newItems;

    this._virtualHeight = this.items.length * this.rowHeight;
    this._realHeight = this.items.length * this.rowHeight;
    // change these numbers to make scroll to work good in all browsers
    var pageSmooth = newItems.length < 20 ? 1 : (newItems.length > 500 ? 100 : 10);
    this._pageHeight = this._realHeight / pageSmooth;
    this._pagesNumber = Math.ceil(this._virtualHeight / this._pageHeight);
    this._jumpCoef = (this._virtualHeight - this._realHeight) / (this._pagesNumber - 1);

    this.resetScroll();
};

//-------------------------------------------
VirtualScrollViewModel.prototype.resetScroll = function () {
    this._page = 0;
    this._offset = 0;
    this._prevScrollTop = 0;

    this.removeAllRows();

    this.$viewport.css("height", this.viewportHeight);
    this.$content.css("height", this._realHeight);

    this.onScroll();
};

//-------------------------------------------
VirtualScrollViewModel.prototype.onNearScroll = function virtualScrollViewModelOnNearScroll() {
    var scrollTop = this.$viewport.scrollTop();

    // next page
    if (scrollTop + this._offset > (this._page + 1) * this._pageHeight) {
        this._page += 1;
        this._offset = Math.round(this._page * this._jumpCoef);
        this._prevScrollTop = scrollTop - this._jumpCoef;
        this.$viewport.scrollTop(this._prevScrollTop);
        this.removeAllRows();
    } else if (scrollTop + this._offset < this._page * this._pageHeight) {
        // prev page
        this._page -= 1;
        this._offset = Math.round(this._page * this._jumpCoef);
        this._prevScrollTop = scrollTop + this._jumpCoef;
        this.$viewport.scrollTop(this._prevScrollTop);
        this.removeAllRows();
    } else {
        this._prevScrollTop = scrollTop;
    }
};

//-------------------------------------------
VirtualScrollViewModel.prototype.onJump = function virtualScrollViewModelOnJump() {
    var scrollTop = this.$viewport.scrollTop();

    this._page = Math.floor(scrollTop * ((this._virtualHeight - this.viewportHeight) / (this._realHeight - this.viewportHeight)) * (1 / this._pageHeight));
    this._offset = Math.round(this._page * this._jumpCoef);
    this._prevScrollTop = scrollTop;

    this.removeAllRows();
};

//-------------------------------------------
VirtualScrollViewModel.prototype.removeAllRows = function virtualScrollViewModelRemoveAllRows() {
    var prop;
    for (prop in this.rows) {
        if (this.rows.hasOwnProperty(prop)) {
            this.rows[prop].remove();
            delete this.rows[prop];
        }
    }
};

//-------------------------------------------
VirtualScrollViewModel.prototype.renderViewport = function virtualScrollViewModelRenderViewport() {
    // calculate the viewport + buffer
    var i,
        item,
        y = this.$viewport.scrollTop() + this._offset,
        buffer = this.viewportHeight,
        top = Math.floor((y - buffer) / this.rowHeight),
        bottom = Math.ceil((y + this.viewportHeight + buffer) / this.rowHeight);

    top = Math.max(0, top);
    bottom = Math.min(this._virtualHeight / this.rowHeight, bottom);

    // remove rows no longer in the viewport
    for (i in this.rows) {
        if (this.rows.hasOwnProperty(i)) {
            if (i < top || i > bottom) {
                this.rows[i].remove();
                delete this.rows[i];
            }
        }
    }

    // add new rows
    for (i = top; i <= bottom; i += 1) {
        if (!this.rows[i]) {
            item = this.renderRow(i);
            if (item) {
                this.rows[i] = item;
            }
        }
    }
};

//-------------------------------------------
VirtualScrollViewModel.prototype.renderRow = function virtualScrollViewModelRenderRow(rowNumber) {

    if (!this.items[rowNumber]) {
        return null;
    }

    var bindingContext,
        item = $(this.itemTemplate);

    // append item to DOM
    this.$content.append(item);

    // create binding context
    bindingContext = createKoBindingContext(this.items[rowNumber], this.rootBindingContext);

    // apply binding
    ko.applyBindings(bindingContext, item[0]);
    item.css({
        top: rowNumber * this.rowHeight - this._offset
    });

    return item;
};

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
//  The "virtualScroll" binding
//  Adds virtual scrolling behavior to list of elements
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
module.exports = {
    init: function virtualScrollBindingInit(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {

        var value = valueAccessor(),
            vm = ko.utils.unwrapObservable(value),
            virtualScroll,
            containerTemplate = ko.utils.unwrapObservable(vm.containerTemplate),
            itemTemplate = ko.utils.unwrapObservable(vm.itemTemplate),
            $content = $(containerTemplate);

        $(element).append($content);

        virtualScroll = new VirtualScrollViewModel(ko.utils.unwrapObservable(vm.items),
                                $(element), $content, ko.utils.unwrapObservable(vm.size),
                                itemTemplate, bindingContext);

        // store virtualScroll object
        ko.utils.domData.set(element, "virtualScroll", virtualScroll);

        return { controlsDescendantBindings: true };
    },

    update: function virtualScrollBindingUpdate(element, valueAccessor) {
        var value = valueAccessor(),
            vm = ko.utils.unwrapObservable(value),
            virtualScroll = ko.utils.domData.get(element, "virtualScroll"); // re-store virtualScroll object

        virtualScroll.updateItems(ko.utils.unwrapObservable(vm.items));
    }
};




//////////////////
// WEBPACK FOOTER
// ./~/pli/forms-knockoutcontrols-multiselect/virtualScrollBindings.js
// module id = 444
// module chunks = 49